module.exports = __webpack_public_path__ + "static/media/arrow-yellow.47dcae82.svg";